import React, { ReactNode, FC, useContext, ComponentType, useMemo } from 'react';
import { ThemeContext } from 'styled-components';

import { StyledWrapper, StyledOverlay } from './ContentLoader.styles';

export interface ContentLoaderProps {
  /** Content to dispay in the loader.  */
  content: ReactNode;
  CustomLoader?: ComponentType;
}

interface ContentLoaderStatics {
  contentLoader: boolean;
}

const ContentLoader: FC<ContentLoaderProps> & ContentLoaderStatics = ({ content, CustomLoader, ...props }) => {
  const {
    assets: { mainLoader: ThemeMainLoader },
  } = useContext(ThemeContext);

  const Loader = useMemo(() => CustomLoader || ThemeMainLoader, [CustomLoader, ThemeMainLoader]);

  return (
    <StyledWrapper data-testid="ContentLoader">
      {content}
      <StyledOverlay>
        <Loader {...props} />
      </StyledOverlay>
    </StyledWrapper>
  );
};

ContentLoader.contentLoader = true;

export default ContentLoader;
